import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import ChatActions from './chat-actions';

const initialState = Immutable({
  chatKitMethod:  null,
  chatKitPayload: null,
});

const reducer = createReducer((on) => {
  on(ChatActions.performChatCommand, (state, { command, payload }) =>
    state.set('chatKitMethod', command).set('chatKitPayload', payload)
  );

  on(ChatActions.reset, () => initialState);
}, initialState);

export default reducer;
